"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentFile = void 0;
const uuid_1 = require("uuid");
const base_model_1 = require("../base-model");
const attachment_file_schema_1 = require("./attachment-file.schema");
const enums_1 = require("../../enums");
class AttachmentFile extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {
            id: (0, uuid_1.v4)(),
            createdAt: Date.now(),
            metadata: {},
            allowedTypeList: Object.values(enums_1.AttachmentFileType),
        };
    }
    getSchema() {
        return attachment_file_schema_1.attachmentFileSchema;
    }
}
exports.AttachmentFile = AttachmentFile;
